import { library as coreLibrary } from "./Core";
import { library as leicesterLibrary } from "./Leicester";
import { library as mediaLibrary } from "./Media";
import { library as profileLibrary } from "./Profile";
import { library as retailLibrary } from "./Retail";
import { library as statsLibrary } from "./Stats";


export const library = {
  ...coreLibrary,
  ...leicesterLibrary,
  ...mediaLibrary,
  ...profileLibrary,
  ...retailLibrary,
  ...statsLibrary,
};
